import { ERulerActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const enableRuler = actionGenerator<ERulerActionType.RulerEnabled>(ERulerActionType.RulerEnabled);
